import React, { Component } from 'react'
import TablaLecturaDeSilos from '../components/TablaLecturaDeSilos'

class LecturaSilos extends Component {
  render () {
    const { valoresSilo } = this.props

    let valores
    if (valoresSilo != null) {
      valores = valoresSilo.filter(valor => (valor !== '0') && (valor !== '') && (valor !== '0.0'))
    }

    const columns = ['Silo', 'Valor']

    return (
      <>
        <h6 className='nombre-tabla-cm'>Nivel de silos sanitarios</h6>
        <div className='tabla-valores-silo'>
          <TablaLecturaDeSilos valores={valores} columns={columns} />
        </div>
      </>
    )
  }
}

export default LecturaSilos
